export function markTiming(name) {
  if (window.performance && window.performance.mark) {
    window.performance.mark('mm_' + name)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/performanceTimings.js